
export type GetUserProfile500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
